exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n@media (min-width: 768px) {\n.quotation-grid {\n    grid-template-columns: 1fr 270px;\n}\n}\n\n/* purgecss end ignore */\n", ""]);
